if (!customElements.get('bundle-options')) {
  class BundleOptions extends HTMLElement {
    constructor() {
      super()

      this.bundleOptions = this.querySelectorAll('input[name="bundle-option"]')
      this.bundlesContainer = this.querySelector('.js-packs')
      this.bundlePacks = this.querySelectorAll('input[name="bundle-option-pack"]')
      this.init()
    }

    init() {
      this.bundleOptions.forEach((input) => {
        input.addEventListener('change', () => {
          if (input instanceof HTMLInputElement) {
            const value = input.value
            const quantityInput = document.querySelector('input[name="quantity"]');
            const quantityWrapper = document.querySelector('.product-form__quantity');
            const buttonSection = document.querySelector('.product-form__quantity-and-buttons');

            if (value === 'single') {
              if (quantityInput) {
                quantityInput.value = 1
              }
              this.bundlesContainer.classList.add('visually-hidden')
              if (quantityWrapper) {
                quantityWrapper.classList.add('visually-hidden');
              }
              if (buttonSection) {
                buttonSection.style.display = 'grid';
              }
            }

            if (value === 'bundle') {
              this.bundlesContainer.classList.remove('visually-hidden')
              const selectedSize = this.querySelector('input[name="bundle-option-pack"]:checked').value
              const quantityInput = document.querySelector('input[name="quantity"]');
              if (quantityInput) {
                quantityInput.value = selectedSize;
              }
              if (quantityWrapper) {
                quantityWrapper.classList.add('visually-hidden');
              }
              if (buttonSection) {
                buttonSection.style.display = 'block';
              }
            }
          }
        })
      })

      this.bundlePacks.forEach((input) => {
        input.addEventListener('change', () => {
          if (input instanceof HTMLInputElement) {
            const size = input.value

            document.querySelector('input[name="quantity"]').value = size
          }
        })
      })
    }
  }
  customElements.define('bundle-options', BundleOptions)
}
